import React, { Component } from 'react';
import WidgetModalForm, { ModalFormContext } from '../../../components/Modal/modalForm.component';

export default class CancelarModalOficio extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const {
			isOpenCancelarOficio,
			handleCloseCancelar,
			handleSubmitCancelar,
		} = this.props;
		return (
			<WidgetModalForm
				textCancelar='Fechar'
				textConfirmar='Confirmar'
				title='Cancelar ofício'
				confirmar={handleSubmitCancelar}
				isOpen={isOpenCancelarOficio}
				cancelar={handleCloseCancelar}
				iconCancelar='fas fa-times'
				iconConfirmar='fas fa-check'
			>
				<ModalFormContext.Consumer>
					{() => (
						<div>
							<p>Tem certeza que deseja cancelar o ofício?</p>

						</div>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}
